import type { ShortsEntryContext } from './types';

const SHORTS_ENTRY_KEY = Symbol('shorts-entry-context') as InjectionKey<
	Readonly<Ref<ShortsEntryContext | undefined>>
>;

/**
 * Provides the Shorts entry-point context for Mixpanel analytics.
 * Call once at the top of the component tree (e.g. PropertyReelsFeed).
 */
export function provideShortsEntry(
	entry: MaybeRefOrGetter<ShortsEntryContext | undefined>
): void {
	provide(SHORTS_ENTRY_KEY, readonly(toRef(entry)));
}

/**
 * Injects the Shorts entry-point context provided by an ancestor.
 * Returns a readonly ref that may be `undefined` when not inside a shorts feed.
 */
export function useShortsEntryContext(): Readonly<
	Ref<ShortsEntryContext | undefined>
> {
	return inject(
		SHORTS_ENTRY_KEY,
		readonly(ref<ShortsEntryContext | undefined>(undefined))
	);
}
